import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalDataService {
  demoAccounts: string[] = [ 'test', 'testl', 'testv', 'demogalmet' ];

  constructor() { }
}
